module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.compIsVisible) ? _c('button', {
    staticClass: "add_upright",
    class: {
      'to-bottom': _vm.toBottom
    },
    on: {
      "click": _vm.emitClick
    }
  }, [_c('img', {
    attrs: {
      "src": "/images/add-accent.svg"
    }
  })]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-179ffacc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/elements/AddUprightBtn.vue
// module id = 626
// module chunks = 0